import { render, staticRenderFns } from "./PageHeaderWithTab.vue?vue&type=template&id=20d71c7a"
import script from "./PageHeaderWithTab.vue?vue&type=script&lang=js"
export * from "./PageHeaderWithTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports